import { CLIENT_ID, TOKEN, USER_ID } from "../constants/localstoregeConstants";

export const getAllRequiredHeaders = ({ rbu = "", ruep = "", url }) => {
  // rbu = request base url
  // ruep = request url end point

  let headers = {};

  headers["rbu"] = rbu;

  if (url.includes("admin_login")) {
    headers["token-id"] = 0;
    headers["user-id"] = 0;
  } else {
    headers["token-id"] = localStorage.getItem(TOKEN);
    headers["user-id"] = localStorage.getItem(USER_ID);
    headers["client-id"] = localStorage.getItem(CLIENT_ID);
  }

  headers["device-type"] = "AML9327483";
  headers["origin"] = "https://laundryadmin.majesticerp.dev";

  return {
    ...headers,
  };
};



// WEBPACK FOOTER //
// ./src/utils/apiUtils/appUtils.js